import React, { FC } from 'react';

import { AppFieldBox } from 'components/appComponents';
import { TextArea } from 'devextreme-react';

type PhoneProps = {
  value: string;
  readOnly: boolean;
  onChange: (value: string) => void;
};

const Phone: FC<PhoneProps> = ({ value, readOnly, onChange }) => {
  return (
    <AppFieldBox label="Конструкция" labelTop>
      <TextArea
        stylingMode="underlined"
        readOnly={readOnly}
        placeholder="Введите комментарий"
        mode="text"
        value={value}
        onChange={(e: any) => {
          onChange(e.event.currentTarget.value);
        }}
      />
    </AppFieldBox>
  );
};

export default Phone;
